import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a28bd5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-max-w-full" }
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_3 = { class: "tw-relative tw-ml-5" }
const _hoisted_4 = {
  key: 0,
  class: "tw-w-[40px] tw-h-[40px] tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[75px] tw-bg-cyan-50 tw-rounded-full tw-border-solid tw-border-white"
}
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-[16px]" }
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-1 tw-mt-4" }
const _hoisted_7 = { class: "tw-text-xl tw-font-bold tw-leading-6 tw-text-[#0C0F4A]" }
const _hoisted_8 = {
  key: 0,
  class: "tw-text-[10px] tw-font-[600] tw-text-[#0C0F4A80]"
}
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-3 tw-mt-1" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-font-font-semibold tw-text-xs tw-text-[#0C0F4A80]" }
const _hoisted_11 = {
  key: 0,
  class: "tw-flex tw-items-center"
}
const _hoisted_12 = { class: "tw-flex tw-items-center tw-gap-2 tw-mt-3" }
const _hoisted_13 = { class: "tw-flex tw-items-center" }
const _hoisted_14 = { class: "tw-pl-[4px] tw-text-xs tw-font-semibold tw-text-[#1FB27A]" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-text-[#0C0F4A] tw-ml-1" }, " Exp. ", -1))
const _hoisted_16 = { class: "tw-flex tw-gap-1 tw-items-center" }
const _hoisted_17 = { class: "category__icon tw-w-[16px] tw-h-[16px] tw-rounded-full tw-bg-[#0c0f4a] tw-flex tw-items-center tw-justify-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "tw-font-bold tw-text-[#0C0F4A] tw-text-xs tw-truncate tw-max-w-[50px] tw-inline-block" }
const _hoisted_20 = {
  key: 1,
  class: "tw-font-bold tw-text-[#0C0F4A] tw-text-xs tw-bg-[#0c0f4a0a] tw-rounded-xl tw-inline-block tw-px-4 tw-py-2 tw-truncate-[unset] tw-whitespace-nowrap"
}
const _hoisted_21 = { class: "tw-mt-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-gray-200 tw-mb-1" }, null, -1))
const _hoisted_23 = { class: "tw-grid tw-grid-cols-3 tw-my-2" }
const _hoisted_24 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Start Date ", -1))
const _hoisted_26 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A] tw-whitespace-nowrap" }
const _hoisted_27 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center tw-border-0 tw-border-solid tw-border-l tw-border-r tw-border-[#F1F6FB]" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Duration ", -1))
const _hoisted_29 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A]" }
const _hoisted_30 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Cost ", -1))
const _hoisted_32 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A]" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-gray-200 tw-mt-1" }, null, -1))
const _hoisted_34 = { class: "tw-w-full tw-grid tw-grid-cols-1 tw-items-center tw-gap-3" }

import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import EstimateBadge from "@/core/uni-components/EstimateBadge.vue";
import ImageHolder from "@/core/uni-components/ImageHolder.vue";
import CustomBadge from "@/core/uni-components/CustomBadge.vue";
import { computed, ref } from "vue";
import moment from "moment";
import { USER_STORE } from "@/store/modules/user";
import { onMounted } from "vue";
import {
  getImageStringToImageURL,
  getUserSubSkillList,
} from "@/core/utils/common";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import ChipState from "@/core/components/common/ChipState.vue";
import { EstimateTypeForDeposit } from "@/core/enums/estimateEnum";

export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateApproveModal',
  props: {
  estimateData: {
    type: Object,
  },
},
  emits: ["on-back-project", "on-deposit"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;
const modalHeader = {
  title: "Estimate send for approval!",
  description: "Estimate provided by",
};
const totalSubTotal = computed(() => {
  const sum = props.estimateData.estimationPhase.reduce((sum, phase) => {
    const roundedSubTotal = parseFloat(phase.subTotal);
    return sum + roundedSubTotal;
  }, 0);
  return Math.round(sum * 100) / 100;
});

const totalVat = computed(() => {
  const sum = props.estimateData.estimationPhase.reduce((sum, phase, index) => {
    const roundedTotalVat = parseFloat(phase.subTotal * phase.vat);
    return sum + roundedTotalVat;
  }, 0);
  return Math.round(sum * 100) / 100;
});

const serviceCharges = computed(() => {
  const initialProjectCharge = 5;
  const serviceFeePercentage = 0.03;
  let totalWithServiceFee = props.estimateData.estimationPhase.reduce(
    (sum, phase, index) => {
      const roundedTotalWithServiceFee = parseFloat(
        phase.subTotal * serviceFeePercentage
      );
      return sum + roundedTotalWithServiceFee;
    },
    0
  );

  totalWithServiceFee += initialProjectCharge;
  return Math.round(totalWithServiceFee * 100) / 100;
});

const customerTotal = computed(() => {
  let total = totalSubTotal.value + totalVat.value + serviceCharges.value;
  if (props.estimateData.grantAmount) {
    total -= props.estimateData.grantAmount;
  }
  return Math.round(parseFloat(total) * 100) / 100;
});
const onClickBack = () => {
  emits("on-back-project", false);
};

const onClickDepositFunds = () => {
  emits("on-deposit");
};

const duration = computed(() => {
  if (
    !props.estimateData?.suggestedStartDate ||
    !props.estimateData?.projectEstimateEndDate
  ) {
    return 0;
  }

  const startDate = moment(props.estimateData?.suggestedStartDate) as any;
  const endDate = moment(props.estimateData?.projectEstimateEndDate) as any;

  const totalDays = endDate.diff(startDate, "days");

  if (totalDays % 7 === 0) {
    const totalWeeks = totalDays / 7;
    return `${totalWeeks} week${totalWeeks > 1 ? "s" : ""}`;
  }

  return `${totalDays} day${totalDays > 1 ? "s" : ""}`;
});
const formattedDate = computed(() => {
  if (!props.estimateData?.suggestedStartDate) {
    return "N/A";
  }
  const date = new Date(props.estimateData?.suggestedStartDate);
  const options = { day: "2-digit", month: "long", year: "numeric" } as any;
  return date.toLocaleDateString("en-GB", options);
});

const displayedSkills = computed(() => {
  return props.estimateData?.workStation?.user?.userSkills.slice(0, 2);
});

const remainingCount = computed(() => {
  return props.estimateData?.workStation?.user?.userSkills.length - 2;
});

const store = useStore();
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);

const getUserSkillList = computed(() => {
  const result = getUserSubSkillList(
    displayedSkills.value,
    getAllSpecialism.value
  );
  return result;
});

const onClickShowRemainingSkill = () => {
  displayedSkills.value = props.estimateData?.workStation?.user?.userSkills;
  remainingCount.value = 0;
};
const subContractorsImages: any = ref([]);
const setSubContractorsProfileImages = async () => {
  for (const contractors of props.estimateData?.inviteContractors) {
    const imageUrl = await getImageStringToImageURL(
      contractors?.toContractorWorkstation?.profileImage
    );
    if (imageUrl) {
      subContractorsImages.value.push(imageUrl);
    }
  }

  const imageUrl = await getImageStringToImageURL(
    props.estimateData?.workStation?.profileImage
  );
  if (imageUrl) {
    subContractorsImages.value.push(imageUrl);
  }
};

const getEstimateDepositType = computed(() => {
  if (
    props.estimateData?.depositType == EstimateTypeForDeposit.Initial_Estimate
  ) {
    return "Initial Estimate";
  } else if (
    props.estimateData?.depositType ==
    EstimateTypeForDeposit.Fixed_Cost_Estimation
  ) {
    return "Fixed Cost Estimate";
  } else if (
    props.estimateData?.depositType ==
    EstimateTypeForDeposit.Variable_Cost_Estimation
  ) {
    return "Variable Cost Estimate";
  } else {
    return "Initial Estimate";
  }
});
onMounted(async () => {
  try {
    setSubContractorsProfileImages();
    if (!getAllSpecialism.value.length) {
      await store.dispatch(
        `${USER_STORE}/setAllSpecialismsCategory`,
        activeUserWorkstation.value.id
      );
    }
  } catch (error) {
    console.log();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    headerTitle: modalHeader.title,
    headerDescription: modalHeader.description,
    onOnClose: _ctx.onCloseModal,
    isShowCloseButton: false,
    width: "430px",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subContractorsImages.value.slice(0, 3), (imgUrl) => {
              return (_openBlock(), _createBlock(ImageHolder, {
                key: imgUrl,
                imageUrl: imgUrl,
                class: "tw-ml-[-20px] !tw-h-[40px] !tw-w-[40px]"
              }, null, 8, ["imageUrl"]))
            }), 128)),
            (subContractorsImages.value?.length > 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "700",
                    textColor: "#4B4BFF",
                    textSize: "24px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" +" + _toDisplayString(subContractorsImages.value?.length - 3), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(EstimateBadge, {
              badge: getEstimateDepositType.value,
              bgColor: "#6B5F4B"
            }, null, 8, ["badge"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(__props.estimateData?.workStation?.name), 1),
          (subContractorsImages.value?.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " +" + _toDisplayString(subContractorsImages.value.length - 1) + " more ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString(__props.estimateData?.workStation?.user?.userBusinessDetails?.type), 1),
            (__props.estimateData?.workStation?.user?.postcode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-map-marker",
                    size: "12px"
                  }),
                  _createTextVNode(" " + _toDisplayString(__props.estimateData?.workStation?.user?.postcode), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_icon, {
              class: "tw-text-[12px]",
              icon: "mdi-check-circle",
              color: "green"
            }),
            _createElementVNode("span", _hoisted_14, _toDisplayString(__props.estimateData?.workStation?.experience
                  ? `${__props.estimateData?.workStation?.experience} + Yrs `
                  : "N/A"), 1),
            _hoisted_15
          ]),
          (getUserSkillList.value.length)
            ? (_openBlock(), _createBlock(CustomBadge, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList.value.slice(0, 2), (skill) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "tw-flex tw-gap-1 tw-items-center tw-bg-[#0c0f4a0a] tw-rounded-xl tw-inline-block tw-px-4 tw-py-2",
                        key: skill.id
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("img", {
                            class: "tw-w-[10px] tw-h-[10px]",
                            src: 
                      require('@/assets/category-icons/' +
                        skill?.iconName +
                        '.svg')
                    ,
                            alt: "image"
                          }, null, 8, _hoisted_18)
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(skill?.label), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (getUserSkillList.value.length > 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " +" + _toDisplayString(getUserSkillList.value.length - 2) + " More ", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(formattedDate.value), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, _toDisplayString(duration.value), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, " £ " + _toDisplayString(customerTotal.value), 1)
            ])
          ]),
          _hoisted_33
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("section", _hoisted_34, [
        _createVNode(Button, {
          variant: "tertiary",
          label: "Back To Project",
          onClick: onClickBack,
          class: "button button-purple-border"
        })
      ])
    ]),
    _: 1
  }, 8, ["headerTitle", "headerDescription", "onOnClose"]))
}
}

})